import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {HttpClient} from "@angular/common/http";
import {first, take} from "rxjs/operators";
import {FilterService} from "./filter.service";
import {Post} from "../interface/post";
import {DOCUMENT} from "@angular/common";
import {Uuid} from "../interface/response/uuid";

@Injectable({
  providedIn: 'root'
})
export class PostService {
  public readonly postListSubject: ReplaySubject<CountedAndPaginated<Post>>
    = new ReplaySubject<CountedAndPaginated<Post>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) {
  }

  public send(formData: object, postId: string): Observable<any> {
    if (!postId) {
      return this.httpClient.post(`/rest/crm360/asf24/post`, formData)
        .pipe(take(1));
    } else {
      return this.httpClient.put(`/rest/crm360/asf24/post/${postId}`, formData)
        .pipe(take(1));
    }
  }

  public loadList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm360/asf24/post?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(take(1))
      .subscribe((result: CountedAndPaginated<Post>) => {
        this.postListSubject.next(result);
      });
  }

  public getPostListSubject(): ReplaySubject<CountedAndPaginated<Post>> {
    return this.postListSubject;
  }

  public get(postId: string): Observable<Post> {
    return this.httpClient.get(`/rest/crm360/asf24/post/${postId}`)
      .pipe(first()) as Observable<Post>;
  }

  delete(postId: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm360/asf24/post/${postId}`)
      .pipe(first());
  }

  copy(postId: string): Observable<any> {
    return this.httpClient.post(`/rest/crm360/asf24/post/copy/${postId}`, {})
      .pipe(first());
  }

  deleteAttachment(attachmentId: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm360/asf24/post/attachment/${attachmentId}`)
      .pipe(first());
  }

  public downloadAttachment(uuid: string): void {
    this.document.location.href = `/rest/crm360/asf24/post/attachment/${uuid}/downloadAttachment`;
  }

  public downloadAttachmentFile(fileLocation: string, fileName: string): void {
    this.document.location.href = `/rest/crm/asf360/file/${fileLocation}/image/${fileName}`;
  }

  public downloadReportCta(filters: object): void {
    this.document.location.href = `/rest/crm/asf360/post/cta/method/report?` + this.filterService.parseFilters(filters);

    // return this.httpClient.post(`/rest/crm/post/cta/method/report?` + this.filterService.parseFilters(filters), {})
    //   .pipe(first()) as Observable<Uuid>;
  }

  public downloadReport(filters: object): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm360/asf24/post-list/method/report?&` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }
}
